'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Pane$Genetics = require("./Pane.bs.js");
var PaneData$Genetics = require("./PaneData.bs.js");
var LoadCodons$Genetics = require("./LoadCodons.bs.js");

function Output(Props) {
  var strand = Props.strand;
  var baseType = Props.baseType;
  var colorBases = Props.colorBases;
  var match = React.useState((function () {
          return [];
        }));
  var setCodonSource = match[1];
  React.useEffect((function () {
          LoadCodons$Genetics.load(/* () */0).then((function (res) {
                  return Promise.resolve(Curry._1(setCodonSource, (function (param) {
                                    return res;
                                  })));
                }));
          return ;
        }), ([]));
  var renderPanes = $$Array.map((function (param) {
          var title = param.title;
          return React.createElement(Pane$Genetics.make, {
                      title: title,
                      data: param.data,
                      colorOn: param.colorOn,
                      key: title
                    });
        }), PaneData$Genetics.displayPane(strand, match[0], baseType, colorBases));
  return React.createElement("div", {
              id: "output"
            }, renderPanes);
}

var make = Output;

exports.make = make;
/* react Not a pure module */
